import { useState } from "react";
import { Navigate, Route, Routes } from "react-router";
import "bootstrap/dist/css/bootstrap.min.css";
import "../styles/ventures.css";
import Navbar from "./components/Navbar";
import Footer from "./components/Footer";
import InvestmentModal from "./components/InvestmentModal";
import ScrollToTop from "./components/ScrollToTop";
import HomePage from "./pages/HomePage";
import AboutPage from "./pages/AboutPage";
import HowItWorksPage from "./pages/HowItWorksPage";
import ContactPage from "./pages/ContactPage";
import BlogIndexPage from "./pages/BlogIndexPage";
import BlogArticlePage from "./pages/BlogArticlePage";

function App() {
  const [isInvestmentModalOpen, setIsInvestmentModalOpen] = useState(false);
  const openAdvisor = () => setIsInvestmentModalOpen(true);

  return <div style={{ minHeight: "100vh", background: "#f1f5f9" }}>
      <ScrollToTop />
      <Navbar onAdvisorClick={openAdvisor} />
      <InvestmentModal open={isInvestmentModalOpen} onOpenChange={setIsInvestmentModalOpen} />

      <Routes>
        <Route path="/" element={<HomePage onAdvisorClick={openAdvisor} />} />
        <Route path="/about" element={<AboutPage />} />
        <Route path="/how-it-works" element={<HowItWorksPage />} />
        <Route path="/contact" element={<ContactPage />} />
        <Route path="/blog" element={<BlogIndexPage onAdvisorClick={openAdvisor} />} />
        <Route path="/blogs" element={<Navigate to="/blog" replace />} />
        <Route path="/blog/:slug" element={<BlogArticlePage onAdvisorClick={openAdvisor} />} />
        <Route path="*" element={<Navigate to="/" replace />} />
      </Routes>

      <Footer />
    </div>;
}

export default App;
